"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = Dropdown;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _react2 = require("../..");

require("@zebra-fed/icons/Navigation/index.css");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    box-shadow: ", ";\n    cursor: pointer\n    width: fit-content;\n    position: relative;\n    font-family: ", ";\n    color: ", ";\n    font-size: ", "rem;\n    height: ", "px;\n    > div {\n        overflow: hidden;\n    }\n    .dropDown {\n        display: inline-flex;\n        height: ", "px;\n        line-height: ", "px;\n        width: 100%;\n        background-color: ", ";\n        border-bottom: ", ";\n        position: relative;\n        > div:first-of-type:not(:empty) {\n            overflow: hidden;\n            text-overflow: ellipsis; \n            white-space: nowrap;\n        }\n        > div:empty:before {\n            content: attr(placeholder);\n            color: ", ";\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            position: absolute;\n            right: ", "px;\n            left: ", "px;\n        }\n    }\n    .dropDownList {\n        position: absolute;\n        top: ", "px;\n        width: 100%;\n        z-index:50;\n        background-color: ", ";\n        box-shadow: ", ";\n        height: ", "; \n        overflow-y: auto;\n        overflow-x: hidden;\n        margin: 0;\n        padding-left: 0px;\n        padding-right: 0px;\n        padding-top: ", "px;\n        padding-bottom: ", "px; \n        > li {\n            display: block;\n            overflow: hidden;\n            width: 100%;\n            height: ", "px;\n            padding-right: ", ";\n            padding-left: ", ";\n            line-height: ", "px;\n            text-overflow: ellipsis;\n            white-space: pre;\n            &:hover {\n                background-color: ", ";\n            }\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.active ? props.colorObj.shadow : null;
}, function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.colorObj.textColor;
}, function (props) {
  return props.spacingObj.fontSize;
}, function (props) {
  return props.spacingObj.height;
}, function (props) {
  return props.spacingObj.height;
}, function (props) {
  return props.spacingObj.lineHeight;
}, function (props) {
  return props.colorObj.backgroundColor;
}, function (props) {
  return props.underline ? "1px solid ".concat(props.colorObj.border) : 'none';
}, function (props) {
  return props.colorObj.placeholderColor;
}, function (props) {
  return props.spacingObj.defaultPadding * 4;
}, function (props) {
  return props.spacingObj.defaultPadding;
}, function (props) {
  return props.spacingObj.height;
}, function (props) {
  return props.colorObj.backgroundColor;
}, function (props) {
  return props.colorObj.shadow;
}, function (props) {
  return props.spacingObj.ulheight;
}, function (props) {
  return props.spacingObj.defaultPadding;
}, function (props) {
  return props.spacingObj.defaultPadding;
}, function (props) {
  return props.spacingObj.height;
}, function (props) {
  return props.spacingObj.padding;
}, function (props) {
  return props.spacingObj.padding;
}, function (props) {
  return props.spacingObj.lineHeight;
}, function (props) {
  return props.colorObj.backgroundHover;
});
/**
 * Dropdowns display a list of choices on temporary surfaces.
 * @example import { Dropdown } from '@desktop/react'; 
 */


function Dropdown(props) {
  var myRef;
  var inherit = 'dropdown';

  var _useState = (0, _react.useState)(props.items),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      active = _useState4[0],
      setActive = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selected = _useState6[0],
      setSelected = _useState6[1];

  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var spacing = context.getSpacing()[inherit][props.type];
  var colors = context.getColors()[inherit];
  (0, _react.useEffect)(function () {
    var children = props.children;
    var buildArr = [];

    if (children) {
      children.map(function (child) {
        buildArr.push({
          name: child.props.children,
          value: child.props.value
        });
      });
      setItems(buildArr);
    }
  }, [props.children]);
  (0, _react.useEffect)(function () {
    if (!active) {
      return;
    }

    document.addEventListener("mousedown", listener);
    return function () {
      document.removeEventListener("mousedown", listener);
    };
  }, [active]);
  (0, _react.useEffect)(function () {
    if (props.defaultValue) {
      setSelected(props.items.indexOf(props.items.find(function (item) {
        return item.name === props.defaultValue;
      })));
    }
  }, []);

  var listener = function listener(event) {
    if (!myRef || myRef.contains(event.target)) {
      return;
    }

    setActive(false);
  };

  function drawSelection() {
    if (selected == null) {
      return '';
    }

    return items[selected].name;
  }

  function clickItem(i) {
    if (selected !== i) {
      setSelected(i);
    }

    setActive(!active);
    props.onChange(i, items[i].name, items[i].value);
  }

  return /*#__PURE__*/_react["default"].createElement(Container, {
    fontFamilyObj: context.getFont(),
    active: active,
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      width: props.width || spacing.width
    }),
    colorObj: colors,
    spacingObj: spacing,
    ref: function ref(_ref) {
      return myRef = _ref;
    },
    type: props.type,
    underline: props.underline
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropDown",
    onClick: function onClick() {
      return setActive(!active);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    placeholder: props.placeholder,
    style: {
      width: '100%',
      paddingLeft: spacing.padding,
      paddingRight: spacing.padding
    }
  }, drawSelection()), /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, props.iconStyle), {}, {
      display: 'grid',
      lineHeight: 'normal',
      margin: 'auto 0px auto auto',
      paddingRight: props.type !== 'xdense' ? spacing.defaultPadding * 2 : spacing.defaultPadding
    })
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    category: 'navigation',
    name: !active ? props.iconName.inactive : props.iconName.active,
    size: spacing.iconSize,
    color: colors.iconColor
  }))), active && /*#__PURE__*/_react["default"].createElement("ul", {
    style: props.dropDownStyle,
    className: "dropDownList"
  }, items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      onClick: function onClick() {
        return clickItem(index);
      },
      key: index
    }, item.name || 'undefined value.');
  })));
}

Dropdown.propTypes = {
  /**The default string used when no value has been set on the DropDown. */
  placeholder: _propTypes["default"].string,

  /**Extends the base styling of the dropdown element. */
  style: _propTypes["default"].object,

  /**Extends the base styling of the area where the menu items are displayed. */
  dropDownStyle: _propTypes["default"].object,

  /**The name of the initial value setting for the DropDown. This will overwrite the placeholder. Given name must be in the items array. */
  defaultValue: _propTypes["default"].string,

  /**The array of items in the dropdown */
  items: _propTypes["default"].array,

  /**Inherits styling based on the type of dropdown to display. Values are default and dense.*/
  type: _propTypes["default"].string,

  /**The callback function that is fired when the value of the dropdown is changed. */
  onChange: _propTypes["default"].func,

  /**Overrides the width of the dropdown. */
  width: _propTypes["default"].string,

  /**Removed the underline from the dropdown. */
  underline: _propTypes["default"].bool
};
Dropdown.defaultProps = {
  placeholder: '',
  style: {},
  dropDownStyle: {},
  defaultValue: '',
  items: [],
  iconName: {
    active: 'up',
    inactive: 'down'
  },
  type: 'default',
  iconStyle: {},
  underline: true,
  onChange: function onChange() {
    return false;
  }
};